// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1iWUq","title":"ClientInsurance_title__1oqMg","itemText":"ClientInsurance_itemText__3E6Ew"};